exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-profile[data-v-30d5ad6f]{min-width:0;display:flex;align-items:center}.fts-profile .profile-name.default-profile-name[data-v-30d5ad6f]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.fts-profile .profile-photo+.profile-name[data-v-30d5ad6f]{margin-left:.275rem}", ""]);

// exports
